console.log("PagePilot initialized");

const pagepilot = {
  init: function () {
    console.log("PagePilot initialized!");
  },
  scrollToElement: function (scrollElement = null) {
    targetElement = null;
    if (scrollElement) {
      scrollElement = scrollElement.replace(/([\[\]])/g, "\\$1");
      console.log(scrollElement);
      targetElement = document.querySelector(`${scrollElement}`);
    }
    if (!targetElement) {
      const classNames = [
        "form[action*='/cart/add'] button[type='submit']",
        "button[name='add']",
        ".product-form__submit",
        ".product-form__buttons",
        ".product__info-wrapper",
        ".product-form"
      ];
      for (let className of classNames) {
        targetElement = document.querySelector(`${className}`);
        if (targetElement) break;
      }
    }
    const offset = 250;
    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        window.scrollTo(0, elementPosition - offset);
      } else {
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};

document.addEventListener("DOMContentLoaded", pagepilot.init);

(function () {
  if (!/leak-proof-4-in-1-travel-dispenser/.test(window.location.pathname)) return;
  var css = "@media screen and (max-width: 749px) {"
    + " .product__media-list.grid--peek .grid__item { min-width: 100% !important; width: 100% !important; }"
    + " .product__media-list.grid--peek .grid__item:first-of-type { margin-left: 0 !important; }"
    + "}"
    + " #cc-urg { display: none !important; }";
  var styleEl = document.createElement("style");
  styleEl.id = "cc-mobile-peek-fix";
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
})();

(function () {
  if (!/leak-proof-4-in-1-travel-dispenser/.test(window.location.pathname)) return;

  function findAnchor() {
    var el = document.querySelector('[id^="shopify-section-"][id$="multicolumn_1"]');
    if (el) return el;
    el = document.querySelector('[id^="shopify-section-"][id*="multicolumn_1"]');
    if (el) return el;
    var sections = document.querySelectorAll('[id^="shopify-section-"]');
    if (sections.length) return sections[sections.length - 1];
    var main = document.querySelector('main');
    return main;
  }

  function injectVideoSection() {
    if (document.getElementById("cc-video-feature")) return true;
    var anchor = findAnchor();
    if (!anchor) return false;

    var html = ""
      + "<style>"
      + "#cc-video-feature{max-width:1100px;margin:0 auto;padding:56px 24px;}"
      + "#cc-video-feature .cc-vf-row{display:flex;gap:48px;align-items:center;}"
      + "#cc-video-feature .cc-vf-media{flex:0 0 46%;max-width:46%;border-radius:16px;overflow:hidden;background:#000;position:relative;}"
      + "#cc-video-feature .cc-vf-media video{display:block;width:100%;height:auto;}"
      + "#cc-video-feature .cc-vf-text{flex:1;}"
      + "#cc-video-feature .cc-vf-eyebrow{font-size:11px;letter-spacing:.12em;font-weight:700;text-transform:uppercase;color:#3f6c5e;margin:0 0 12px;}"
      + "#cc-video-feature h2{font-family:Georgia,serif;font-size:clamp(24px,3.4vw,32px);margin:0 0 16px;color:#2b2927;}"
      + "#cc-video-feature p{font-size:14px;line-height:1.75;color:#4c4845;margin:0 0 14px;}"
      + "#cc-video-feature ul{margin:0;padding-left:18px;font-size:13.5px;color:#4c4845;line-height:1.9;}"
      + "@media (max-width:749px){"
      + "#cc-video-feature{padding:40px 20px;}"
      + "#cc-video-feature .cc-vf-row{flex-direction:column;gap:24px;}"
      + "#cc-video-feature .cc-vf-media{max-width:100%;flex:none;width:100%;}"
      + "}"
      + "</style>"
      + "<div id=\"cc-video-feature\">"
      + "<div class=\"cc-vf-row\">"
      + "<div class=\"cc-vf-media\">"
      + "<video autoplay muted loop playsinline controls preload=\"metadata\">"
      + "<source src=\"https://cdn.shopify.com/videos/c/o/v/2064d23c5872448c93595f70f0bd1b3e.mp4\" type=\"video/mp4\">"
      + "</video>"
      + "</div>"
      + "<div class=\"cc-vf-text\">"
      + "<p class=\"cc-vf-eyebrow\">See It In Action</p>"
      + "<h2>How the 4-in-1 Dispenser Actually Works</h2>"
      + "<p>Twist the rotary dial, press the pump, and the exact product you need comes out — no digging through separate bottles, no guessing which cap belongs to what.</p>"
      + "<ul>"
      + "<li>Rigid outer shell absorbs pressure so nothing leaks in transit</li>"
      + "<li>Clear internal bottles with volume markings</li>"
      + "<li>Wide-mouth refilling, no funnel needed</li>"
      + "</ul>"
      + "</div>"
      + "</div>"
      + "</div>";

    anchor.insertAdjacentHTML("afterend", html);
    return true;
  }

  if (!injectVideoSection()) {
    document.addEventListener("DOMContentLoaded", injectVideoSection);
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (injectVideoSection() || tries > 30) clearInterval(poll);
    }, 250);
  }
})();
